import React from "react";
import Navbar from "./Navbar";
import Input from "./Input";

const App = () => {
  return (
    <>
      <Navbar />
      <div className="container">
        <Input />
      </div>
    </>
  );
};
export default App;
